import { render, staticRenderFns } from "./node-actions.vue?vue&type=template&id=80f0a4fa&scoped=true&"
import script from "./node-actions.vue?vue&type=script&lang=ts&"
export * from "./node-actions.vue?vue&type=script&lang=ts&"
import style0 from "./node-actions.vue?vue&type=style&index=0&id=80f0a4fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f0a4fa",
  null
  
)

export default component.exports